import { bech32m } from 'bech32';
const TAPROOT_WITNESS_VERSION = 1;
export function getTaprootPubToAddress(pubKey) {
    const bufferPubKey = Buffer.from(pubKey.slice(2), 'hex');
    const words = bech32m.toWords(bufferPubKey);
    words.unshift(TAPROOT_WITNESS_VERSION);
    const ad = bech32m.encode('tb', words);
    return ad;
}
